<template>
    <div class="latest-posts panel">
        <div class="panel-heading">
            <h2>
                Latest Forum Posts
                <i
                    class="clippie fa fa-info-circle"
                    v-tooltip="'The most recent posts from all threads in the forum.'">
                </i>
            </h2>
        </div>

        <div class="panel-body">

            <scroll-area
                ref="scrollbar"
                v-if="posts"
                v-once>
                <ul
                    class="post-list"
                    ref="postList">
                    <li
                        :key="post.threadId + '_' + post.id"
                        v-for="post in posts">

                        <ForumPostResult
                            :post="post"
                            :thread="post.thread">
                            <template slot="post-content">
                                <div
                                    class="post-content-html"
                                    v-html="post.content">
                                </div>
                            </template>
                        </ForumPostResult>
                    </li>
                </ul>

                <div class="forum-link">
                    <router-link :to="{ name: 'forum-home' }">
                        Go to forum
                    </router-link>
                </div>
            </scroll-area>
        </div>
    </div>
</template>

<script>
    import ForumService    from '../../services/forum';
    import ForumPostResult from '../reusable/forum/post-result';
    import ScrollArea      from '../reusable/scroll-area';

    export default {
        components: {
            ForumPostResult,
            ScrollArea,
        },

        data() {
            return {
                posts: null,
                limit: 10,
            };
        },

        created() {
            this.refreshPosts();
        },

        watch: {
            posts() {
                this.$nextTick(() => {
                    if (this.$refs.scrollbar) {
                        this.$refs.scrollbar.update();
                    }
                });
            },
        },

        methods: {
            async refreshPosts() {
                this.posts = null;
                const res = await ForumService.searchPosts('', {
                    limit: this.limit,
                    order: 'createdAt:desc',
                    cache: 'forumposts',
                });
                this.posts = res.posts;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .panel-heading {
        // Put box-shadow over posts
        position: relative;
        z-index: 1;
    }

    h2 {
        display: flex;
        align-items: center;

        i {
            width: auto;
            height: auto;
        }
    }

    .scroll-area {
        margin: auto;
        max-height: 1000px;
        padding: 0 20px 20px;
        padding-right: 30px; // Account for scrollbar
    }

    ul.post-list {
        border-bottom: 1px solid #333;
    }

    li {
        list-style: none;

        &:first-of-type {
            .forum-post-result {
                border-top: none;
                margin-top: 7px;
            }
        }

        .forum-post-result {
            border-top: 1px solid #333;
            margin-left: 0;
            margin-right: 0;
        }
    }

    .forum-link {
        margin-top: 10px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// LatestPosts.vue?14406a08